<template>
  <div class="transfer-intercept">
    <iconpark-icon class="close" name="close" @click="onCancelClick"></iconpark-icon>
    <div class="title">{{ $t('dai-zhi-fu-dui-gong-ding-dan-ti-xing') }}</div>
    <div class="desc">
      {{
        $t(
          'nin-cun-zai-dui-gong-zhuan-zhang-ding-dan-shang-wei-wan-cheng-zhi-fu-qing-you-xian-chu-li',
        )
      }}
    </div>
    <div class="block">
      <div class="id">
        <span> {{ $t('ding-dan-hao-0') }} </span>
        <span>{{ order.no }}</span>
      </div>
      <div class="name">
        <span>{{ $t('shang-pin-xin-xi-0') }}</span>
        <span>{{ order.rights_name }}</span>
      </div>
      <div class="num">
        <span>{{ $t('shu-liang-0') }}</span>
        <span>{{ displayNum }}</span>
      </div>
      <div v-if="order.expired_time" class="expired">
        <span>{{ $t('you-xiao-qi-0') }}</span>
        <span>{{ timeFormat(order.expired_time) }}</span>
      </div>
      <div class="amount">
        <span>{{ $t('ding-dan-jin-e') }}</span>
        <span>{{ formatPrice(order.pay_fee).string }}</span>
      </div>
    </div>
    <a-alert
      class="alert"
      :message="$t('ding-dan-jiang-yu-1-tian-nei-zi-dong-qu-xiao-qing-ji-shi-wan-cheng-zhi-fu')"
      type="warning"
      show-icon
    />
    <div class="operation">
      <a-button class="btn-cancel" @click="onCancelOrder">
        {{ $t('qu-xiao-ding-dan') }}
      </a-button>
      <a-button class="go-pay" type="primary" @click="onPay">
        {{ $t('qu-zhi-fu') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useShowPaymentEquity } from '../..';
import { postOrderClientCancel, reqChangePayType } from '~/api';
import { ORDER_TYPE, PAY_TYPE } from '~/api/interface';
import type { IOrder } from '~/api/interface/order';
import { clearModals } from '~/hooks/useModal/modals/empty';
import { useTime } from '~/hooks/useTime.ts';
import { formatByteSize } from '~/utils/helper';

const { timeFormat } = useTime();
const { $t } = useNuxtApp();

const props = defineProps<{
  order: IOrder;
  onCancel: () => void;
  headers?: Record<string, string>;
}>();

const displayNum = computed(() => {
  const order = props.order!;
  switch (order.order_type) {
    case ORDER_TYPE.STORAGE:
      return formatByteSize(order.rights.total_storage);
    case ORDER_TYPE.CREDITS:
      return `${order.rights.total_credit_coin} ${$t('yan-bi')}`;
    default:
      return order.buy_num;
  }
});

const onCancelOrder = async () => {
  await postOrderClientCancel({ id: props.order.id }, { headers: props.headers });
  message.success($t('ding-dan-yi-qu-xiao'));
  props.onCancel();
};

const show = useShowPaymentEquity();

const onCancelClick = () => {
  show.value = false;
  clearModals();
};

const onPay = async () => {
  const res = await reqChangePayType(
    {
      id: props.order.id,
      pay_type: PAY_TYPE.TRANSFER,
    },
    { headers: props.headers },
  );

  if (res.data?.qr_code_url) {
    const qrcode = res.data?.qr_code_url;
    const url = new URL(location.href);
    const doAlert = url.searchParams.get('alert');
    if (doAlert) {
      alert(`${qrcode}xxxx`);
    } else {
      location.href = qrcode;
    }
  }
};
</script>

<style lang="scss" scoped>
.transfer-intercept {
  position: relative;
  padding: 20px;
}
.close {
  cursor: pointer;
}
.title {
  text-align: center;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 10px;
  color: var(--text-1);
}
.desc {
  text-align: center;
  font-size: 14px;
  color: var(--text-1);
  line-height: 22px;
  margin-bottom: 20px;
}
.close {
  position: absolute;
  right: 12px;
  font-size: 16px;
  top: 12px;
  color: var(--back-5);
}
.block {
  background: var(--purple-2);
  border-radius: 10px;
  padding: 18px;
  margin-bottom: 14px;
  > div {
    display: flex;
    &:not(:last-child) {
      margin-bottom: 20px;
    }
    span {
      display: block;
    }
    span:first-child {
      width: 25%;
    }
  }
}
.operation {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>
